import {
  Box,
  Button,
  Container,
  Grid,
  Stack,
  Typography,
  alpha,
  useTheme,
} from '@mui/material';
import React from 'react';
import { ArrowBack } from '@mui/icons-material';

// COMPONENTS
import SideNavigation from '../navigation/SideNavigation';
import { useLocation } from 'react-router-dom';

export default function Layout({
  children,
  routes,
  title,
  accessLevel,
  accessType,
  customerType,
  titleRowRightComponent = null,
  handleBackButton = null,
  backButtonText = '',
  isHidden,
}) {
  const theme = useTheme();
  const location = useLocation();

  const isWebsmsPath = location.pathname.startsWith('/websms');

  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        display: 'flex',
        flex: 1,
      }}
    >
      <Grid
        container
        sx={{
          flexDirection: {
            xs: 'column',
            md: 'row',
            flex: 1,
          },
        }}
      >
        <Grid
          sx={{
            flexDirection: 'column',
            maxWidth: { md: 210 },
            flex: { md: 1 },
            backgroundColor: alpha(theme.palette.primary.main, 0.15),
          }}
          size={{
            xs: 12,
            md: 3,
          }}
        >
          <SideNavigation
            routes={routes}
            accessLevel={accessLevel}
            accessType={accessType}
            customerType={customerType}
            isHidden={isHidden}
          />
        </Grid>

        <Grid
          size="grow"
          sx={{
            backgroundColor: isWebsmsPath ? 'background.main' : 'transparent',
            flex: 1,
            position: 'relative',
          }}
        >
          <Box component="main" id="content">
            {handleBackButton && backButtonText && (
              <Box sx={{ marginY: 1, marginX: 0.5 }}>
                <Button
                  variant="link"
                  color="secondary"
                  startIcon={<ArrowBack />}
                  onClick={handleBackButton}
                  size="small"
                  sx={{ border: 'none', backgroundColor: 'transparent' }}
                >
                  {backButtonText}
                </Button>
              </Box>
            )}
            <Box
              sx={{
                paddingX: { xs: 2, sm: 6 },
                paddingBottom: { xs: 2, sm: 6 },
                paddingTop: handleBackButton && backButtonText ? 0 : 4,
              }}
            >
              <Stack
                sx={{
                  flexDirection: { md: 'row' },
                  justifyContent: 'space-between',
                }}
              >
                <Typography variant="h1" gutterBottom>
                  {title}
                </Typography>

                {titleRowRightComponent}
              </Stack>

              {children}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}
